import { render, staticRenderFns } from "./ProductActivity.vue?vue&type=template&id=26c8b0b8&scoped=true"
import script from "./ProductActivity.vue?vue&type=script&lang=js"
export * from "./ProductActivity.vue?vue&type=script&lang=js"
import style0 from "./ProductActivity.vue?vue&type=style&index=0&id=26c8b0b8&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26c8b0b8",
  null
  
)

component.options.__file = "ProductActivity.vue"
export default component.exports